module.exports = __webpack_public_path__ + "static/media/web-development.cb8113c5.png";